// extracted by mini-css-extract-plugin
export default {"container":"lb","overlay":"mb","videoOverlay":"nb","header":"ob","close":"pb","content":"qb"};